var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.5c0 3.425-2.804 6.212-6.25 6.212H6.643l1.348 1.259c.386.36.396.966.021 1.338l-.42.418c-.367.364-.96.364-1.326 0l-3.62-3.598c-.367-.364-.367-.954 0-1.318l3.62-3.599c.366-.364.96-.364 1.326 0l.42.419c.375.372.365.977-.02 1.338l-1.349 1.258h7.107c2.068 0 3.75-1.672 3.75-3.727 0-.542-.117-1.057-.327-1.522-.159-.351-.09-.762.184-1.034l.476-.473c.45-.447 1.21-.331 1.497.232.428.841.67 1.791.67 2.797zM2.827 11.022c-.21-.465-.327-.98-.327-1.522 0-2.055 1.682-3.727 3.75-3.727h7.107L12.009 7.03c-.386.36-.396.966-.021 1.338l.42.419c.367.364.96.364 1.326 0l3.62-3.599c.367-.364.367-.954 0-1.318L13.735.273c-.366-.364-.96-.364-1.326 0l-.42.418c-.375.372-.365.978.02 1.338l1.349 1.259H6.25C2.804 3.288 0 6.075 0 9.5c0 1.005.242 1.956.67 2.797.287.563 1.048.679 1.497.232l.476-.473c.273-.272.343-.683.184-1.034z",
    transform: "translate(2 2.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.b918f5489bc125e4533a4d6426fe0844.svg";
export { ForwardRef as ReactComponent };